import { createFileRoute, redirect } from "@tanstack/react-router";

// Settings is a tab of Management.
export const Route = createFileRoute("/st-admin/settings/")({
	beforeLoad: () => {
		throw redirect({
			to: "/st-admin/management",
			search: { tab: "settings" },
			replace: true,
		});
	},
});
